import React from "react";

export default function SongkranFrame6({ frameTextToggle, children }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 2000 2000"
      width="300"
      height="300"
      fill="none"
    >
      <g transform={frameTextToggle}>
        <defs>
          <style>{".cls-son61{fill:#ffea6c}.cls-son62{fill:#f7dd5c}"}</style>
        </defs>
        <path
          d="M631.19 605.38 433.5 698.36l9.89-204.58 187.8 111.6z"
          style={{
            fill: "#f94892",
          }}
        />
        <rect
          width={27.44}
          height={497.68}
          x={424.65}
          y={452.74}
          rx={13.72}
          ry={13.72}
          style={{
            fill: "#dd317f",
          }}
        />
        <path
          d="M632.29 1160.51v341.39l-291.49-2.31-237.78-1.89c-25.48-.2-41.19-27.91-28.27-49.87l242.79-412.93h.01l32.56-55.39c17.21-29.26 45.1-45.99 74.54-50.26 9.09-1.33 18.33-1.45 27.44-.39 31.1 3.6 60.79 20.99 78.42 52.08l56.57 99.8 45.22 79.77Z"
          className="cls-son61"
        />
        <path
          d="M632.29 1160.51v236.59l-113.5-200.23-67.18-118.53c-28.3-49.93-87.68-64.52-134.06-43.45h-.01l32.57-55.39c17.21-29.26 45.1-45.99 74.54-50.26 9.09-1.33 18.33-1.45 27.44-.39 31.1 3.6 60.79 20.99 78.42 52.08l56.57 99.8 45.22 79.77Z"
          className="cls-son62"
        />
        <path
          d="M1194.33 284.7 981.37 384.86l10.64-220.39 202.32 120.23z"
          style={{
            fill: "#f45611",
          }}
        />
        <rect
          width={29.56}
          height={536.14}
          x={971.83}
          y={120.26}
          rx={14.78}
          ry={14.78}
          style={{
            fill: "#dd440e",
          }}
        />
        <path
          d="M1707.82 1675.23c-.16-2.85-.51-5.72-1.07-8.57-.39-2.04-.89-4.08-1.5-6.11-1.4-4.74-3.38-9.44-5.98-14.02l-172.05-303.54h-.01l-360.34-635.76c-9.9-17.46-21.71-32.75-34.97-45.86-1.65-1.63-3.33-3.25-5.04-4.82-3.39-3.14-6.88-6.14-10.45-9.02-2.67-2.15-5.4-4.22-8.16-6.23-.92-.67-1.85-1.33-2.77-1.97-2.79-1.94-5.61-3.82-8.47-5.61-3.82-2.4-7.7-4.66-11.65-6.77-1.97-1.06-3.96-2.08-5.95-3.08-5-2.48-10.09-4.75-15.23-6.8-2.07-.82-4.14-1.6-6.22-2.35a209 209 0 0 0-28.65-8.08c-2.16-.45-4.33-.86-6.49-1.23-7.1-1.23-14.26-2.1-21.44-2.59-9.84-.7-19.72-.69-29.56.02a204.237 204.237 0 0 0-20.59 2.47c-4.27.73-8.52 1.59-12.74 2.59-2.12.5-4.22 1.03-6.32 1.59-3.14.85-6.27 1.76-9.38 2.76-3.12 1-6.2 2.07-9.27 3.21-3.07 1.15-6.11 2.36-9.12 3.66-4.03 1.73-8.01 3.58-11.92 5.58-1.96.99-3.91 2.02-5.85 3.09-1.93 1.07-3.85 2.16-5.75 3.29s-3.8 2.29-5.67 3.49c-3.74 2.4-7.44 4.92-11.04 7.57-2.72 1.99-5.38 4.06-8.01 6.21-5.25 4.28-10.33 8.88-15.22 13.77a209.05 209.05 0 0 0-9.5 10.16s-.01 0 0 .01c-1.53 1.75-3.04 3.54-4.54 5.37-.75.92-1.5 1.85-2.22 2.78a215.704 215.704 0 0 0-16.32 23.95l-64.71 110.06-156.58 266.29-68.29 116.13-177.99 302.72-79.69 135.52c-25.67 43.65 5.55 98.71 56.17 99.11l962.94 7.65 207.49 1.64 153.82 1.22c18.78.15 35.02-7.27 46.72-18.9.38-.37.74-.75 1.11-1.14.73-.75 1.44-1.54 2.13-2.32.69-.8 1.37-1.61 2.02-2.43.65-.83 1.28-1.67 1.9-2.51a67.13 67.13 0 0 0 8.18-15.22c3.23-8.49 4.75-17.66 4.22-26.97Zm-471.99-2.6h-528c-41.73 0-75.54-33.81-75.54-75.54v-528c0-41.73 33.81-75.54 75.54-75.54h528c41.73 0 75.54 33.81 75.54 75.54v528c0 41.73-33.81 75.54-75.54 75.54Z"
          style={{
            fill: "#fce700",
          }}
        />
        <path
          d="M1703.6 1702.21c-.94 2.45-2.03 4.85-3.23 7.18-.73 1.39-1.51 2.76-2.33 4.1-.83 1.34-1.71 2.65-2.62 3.94-.62.85-1.25 1.69-1.9 2.51-.66.82-1.33 1.63-2.02 2.43-.69.79-1.4 1.57-2.13 2.32-.37.38-.73.76-1.11 1.14-11.7 11.64-27.94 19.05-46.72 18.9l-153.82-1.22-102.32-180.52-74.01-130.58v-363.32c0-41.73-33.81-75.54-75.54-75.54h-173.22l-52.57-92.75c-56.23-99.22-174.22-128.23-266.4-86.36-.01 0-.02.01-.03.01l64.73-110.08c5.01-8.51 10.47-16.49 16.33-23.94.72-.93 1.46-1.86 2.22-2.78 1.48-1.82 2.99-3.62 4.54-5.37-.01-.01 0-.01 0-.01a199.9 199.9 0 0 1 9.5-10.16c4.88-4.89 9.96-9.48 15.22-13.77 2.62-2.14 5.29-4.21 8.01-6.21 3.61-2.66 7.3-5.19 11.04-7.57a206.956 206.956 0 0 1 11.42-6.78c1.94-1.07 3.89-2.1 5.85-3.09 3.91-1.99 7.89-3.85 11.92-5.58 3.01-1.29 6.06-2.51 9.12-3.66 3.07-1.15 6.15-2.22 9.27-3.21 3.11-1 6.24-1.91 9.38-2.76 2.1-.56 4.2-1.09 6.32-1.59 4.22-1 8.46-1.86 12.74-2.59 2.13-.37 4.27-.7 6.42-1 4.71-.66 9.43-1.16 14.17-1.47 9.84-.71 19.72-.72 29.56-.02 7.18.49 14.34 1.36 21.44 2.59 2.16.37 4.33.79 6.49 1.23 9.69 2 19.27 4.7 28.65 8.08 2.08.75 4.15 1.54 6.22 2.35a204.43 204.43 0 0 1 15.23 6.8c1.99.99 3.98 2.02 5.95 3.08 3.95 2.11 7.83 4.37 11.65 6.77 2.86 1.79 5.69 3.66 8.47 5.61.92.65 1.85 1.3 2.77 1.97 2.76 1.99 5.48 4.07 8.16 6.23 3.56 2.86 7.05 5.87 10.45 9.02 1.71 1.57 3.39 3.18 5.04 4.82 13.26 13.11 25.07 28.41 34.97 45.86l360.34 635.75h.01l172.05 303.55c2.6 4.58 4.58 9.28 5.98 14.02.6 2.03 1.1 4.07 1.5 6.11.55 2.85.9 5.71 1.06 8.56.53 9.31-.98 18.5-4.21 26.98Z"
          style={{
            fill: "#f9c900",
          }}
        />
        <path
          d="m1778.86 1017.17-189.96 89.34 9.5-196.58 180.46 107.24z"
          style={{
            fill: "#bb1def",
          }}
        />
        <rect
          width={26.37}
          height={478.23}
          x={1580.39}
          y={870.49}
          rx={13.19}
          ry={13.19}
          style={{
            fill: "#9530bf",
          }}
        />
        <path
          d="m1897.77 1879.74-640.29-5.09c-24.48-.19-39.57-26.82-27.16-47.92l264.6-450.02c39.05-66.42 135.35-65.65 173.35 1.38l257.42 454.16c12.07 21.3-3.44 47.68-27.92 47.48Z"
          className="cls-son61"
        />
        <path
          d="m1897.77 1879.74-74.37-.59-230.96-407.46c-27.19-47.98-84.26-62.01-128.82-41.75l31.3-53.22c39.06-66.41 135.36-65.65 173.35 1.38l257.43 454.16c12.06 21.3-3.45 47.68-27.92 47.48Z"
          className="cls-son62"
        />
        {children}
      </g>
    </svg>
  );
}
